export const siteLogosRoutes = {
    envia: 'envia',
    ecartPay: 'ecart-pay-color',
    ecartSeller: 'ecart-seller-color',
    fulfillment: 'fulfillment',
    fulfillmentMibox: 'fulfillment-mibox',
    returns: 'returns-color',
    wms: 'wms',
    ecartapi: 'logo-ecartapi',
};

export const siteIconsRoutes = {
    envia: 'envia',
    ecartPay: 'ecart-pay',
    fulfillment: 'fulfillment',
    returns: 'returns',
    wms: 'wms',
};

export const FULFILLMENT_MIBOX_SITE_ID = '66317a0b6c6ae21e0bfb5c9b';

const siteNameToLogoType = {
    'Ecart Pay': 'ecartPay',
    'Returns': 'returns',
    'Fulfillment': 'fulfillment',
    'Envia': 'envia',
    'WMS': 'wms',
    'Ecart API': 'ecartapi',
};

export const getLogoTypeBySiteId = (siteId, sites = []) => {
    if (siteId === FULFILLMENT_MIBOX_SITE_ID) {
        return 'fulfillmentMibox';
    }

    if (!siteId) {
        return 'accounts';
    }

    const site = sites.find(item => item.site_id === siteId);

    if (site && siteNameToLogoType[site.name]) {
        return siteNameToLogoType[site.name];
    }

    return 'accounts';
};

export const getSiteName = (siteId, sites = []) => {
    if (!siteId) {
        return 'Accounts';
    }
    const site = sites.find(item => item.site_id === siteId);
    return site?.name || 'Accounts';
};